
export const SET_SELECTED_OBJECTS = 'SET_SELECTED_OBJECTS';
